import { render, staticRenderFns } from "./ChooseUs.vue?vue&type=template&id=5e3bea2c&scoped=true"
import script from "./ChooseUs.vue?vue&type=script&lang=js"
export * from "./ChooseUs.vue?vue&type=script&lang=js"
import style0 from "./ChooseUs.vue?vue&type=style&index=0&id=5e3bea2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3bea2c",
  null
  
)

export default component.exports